import { render, staticRenderFns } from "./Stree.vue?vue&type=template&id=1020ed60&scoped=true";
import script from "./Stree.vue?vue&type=script&lang=js";
export * from "./Stree.vue?vue&type=script&lang=js";
import style0 from "./Stree.vue?vue&type=style&index=0&id=1020ed60&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1020ed60", null);
export default component.exports;